import styles from "../../styles/_containers/_messageTemplates/templateList.module.scss";
import Loader from "../../components/loader";

export const TEMPLATE_TYPES = [
  { key: "reminder", label: "תזכורת לתור", description: "נשלחת אוטומטית ללקוח לפני מועד התור", color: "#2563EB", bg: "#eff6ff", icon: "🔔" },
  { key: "booking_confirmation", label: "אישור זימון תור", description: "נשלחת ללקוח מיד עם קביעת תור חדש", color: "#16A34A", bg: "#f0fdf4", icon: "✅" },
  { key: "cancellation", label: "ביטול תור", description: "נשלחת ללקוח בעת ביטול תור", color: "#DC2626", bg: "#fef2f2", icon: "❌" },
];

const DEFAULT_MESSAGES = {
  reminder:             "היי {{שם_לקוח}}, אנו מתזכרים אותך לגבי התור שקבעת ל{{שם_עסק}} עבור {{שירות}} מחר בשעה {{שעה}}.",
  booking_confirmation: "היי {{שם_לקוח}}, התור שקבעת ל{{שם_עסק}} עבור {{שירות}} בתאריך {{תאריך}} ובשעה {{שעה}} נקבע בהצלחה!🎉",
  cancellation:         "היי {{שם_לקוח}}, התור שקבעת ל{{שם_עסק}} עבור {{שירות}} בתאריך {{תאריך}} ובשעה {{שעה}} בוטל.",
};

const SAMPLE_VALUES = {
  "{{שם_לקוח}}": "דנה כהן", "{{תאריך}}": "15/04/2026", "{{שעה}}": "10:30",
  "{{שירות}}": "תספורת", "{{עובד}}": "מיכל", "{{שם_עסק}}": "סטודיו ביוטי",
  "{{קישור}}": "https://app.tor.digital/cancel/abc123",
};

const renderPreview = (content) => {
  if (!content) return "";
  return content.replace(/\{\{[^}]+\}\}/g, (token) => SAMPLE_VALUES[token] || token);
};

const TemplateList = ({ templates, loading, onEdit, onToggle, onDelete }) => {
  if (loading) return <div className={styles.loaderWrap}><Loader /></div>;
  return (
    <div className={styles.list}>
      {TEMPLATE_TYPES.map((type) => {
        const template = templates.find((t) => t.type === type.key) || null;
        return (
          <TemplateCard key={type.key} typeInfo={type} template={template}
            onEdit={() => onEdit({ ...template, typeInfo: type })}
            onToggle={() => template && onToggle(template._id)}
            onDelete={() => template && onDelete(template._id)}
          />
        );
      })}
    </div>
  );
};

export default TemplateList;

const TemplateCard = ({ typeInfo, template, onEdit, onToggle, onDelete }) => {
  const isWa = template?.channel === "whatsapp";
  const isActive = template?.isActive ?? false;
  const preview = template ? renderPreview(template.content) : null;

  return (
    <div className={styles.card} style={{ "--type-color": typeInfo.color }}>
      {/* Top: type info + toggle */}
      <div className={styles.cardTop}>
        <div className={styles.typeInfo}>
          <span className={styles.typeIcon}>{typeInfo.icon}</span>
          <div>
            <h3 className={styles.typeName}>{typeInfo.label}</h3>
            <p className={styles.typeDesc}>{typeInfo.description}</p>
          </div>
        </div>
        {template && (
          <button
            className={`${styles.toggle} ${isActive ? styles.toggleOn : styles.toggleOff}`}
            onClick={onToggle} title={isActive ? "השבת" : "הפעל"}
          >
            <span className={styles.toggleThumb} />
          </button>
        )}
      </div>

      {/* Chat preview */}
      {template ? (
        <div className={`${styles.chatWrap} ${isWa ? styles.chatWa : styles.chatSms}`}>
          {/* Channel header bar */}
          <div className={`${styles.chatHeader} ${isWa ? styles.chatHeaderWa : styles.chatHeaderSms}`}>
            <div className={styles.chatAvatar}>{isWa ? "💬" : "📱"}</div>
            <div className={styles.chatHeaderText}>
              <span className={styles.chatName}>דנה כהן</span>
              <span className={styles.chatSub}>{isWa ? "WhatsApp" : "SMS"}</span>
            </div>
            {!isActive && <span className={styles.inactiveBadge}>כבוי</span>}
          </div>

          {/* Messages area */}
          <div className={styles.chatBody}>
            <div className={`${styles.bubble} ${isWa ? styles.bubbleWa : styles.bubbleSms}`}>
              <p className={styles.bubbleText}>{preview}</p>
              <div className={styles.bubbleMeta}>
                <span className={styles.bubbleTime}>10:30</span>
                {isWa && <span className={styles.ticks}>✓✓</span>}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* Default system template banner */}
          <div className={styles.defaultBanner}>
            <span className={styles.defaultBannerTxt}>📋 ברירת מחדל של המערכת — ההודעה שנשלחת כרגע</span>
          </div>

          {/* Default message preview (WhatsApp-style, dimmed) */}
          <div className={`${styles.chatWrap} ${styles.chatWrapDefault} ${styles.chatWa}`}>
            <div className={`${styles.chatHeader} ${styles.chatHeaderWa}`}>
              <div className={styles.chatAvatar}>💬</div>
              <div className={styles.chatHeaderText}>
                <span className={styles.chatName}>דנה כהן</span>
                <span className={styles.chatSub}>WhatsApp</span>
              </div>
            </div>
            <div className={styles.chatBody}>
              <div className={`${styles.bubble} ${styles.bubbleDefault}`}>
                <p className={styles.bubbleText}>{renderPreview(DEFAULT_MESSAGES[typeInfo.key])}</p>
                <div className={styles.bubbleMeta}>
                  <span className={styles.bubbleTime}>10:30</span>
                  <span className={styles.ticks}>✓✓</span>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Footer actions */}
      <div className={styles.cardFooter}>
        <button className={styles.editBtn} style={{ "--c": typeInfo.color }} onClick={onEdit}>
          {template ? "✏️ עריכת תבנית" : "+ צור תבנית"}
        </button>
        {template && (
          <button className={styles.deleteBtn} onClick={onDelete}>מחק</button>
        )}
      </div>
    </div>
  );
};
